<template>
  <div class="flex flex-col bg-white h-full">
    <div class="p-3 sm:p-6 flex flex-col h-full">
      <div>
        <div class="text-2xl sm:text-3xl font-bold mb-6">Sign & accept</div>
        <div
          class="text-sm font-bold"
          v-if="proposal?.start_date"
        >
          Effective date:
          <span class="!font-normal">{{ formatDate(proposal?.start_date) }}</span>
        </div>
      </div>
      <div
        v-html="proposal.terms_and_conditions"
        v-if="proposal.terms_and_conditions"
        class="prose bg-gray-50 p-4 my-3 break-words rounded-lg !max-w-full max-h-[225px] sm:max-h-[350px] overflow-y-auto"
      ></div>
      <div
        v-if="uploadedTermsPdf"
        class="mt-3 mb-6"
      >
        <portal-button
          color="primary"
          class="flex items-center justify-center gap-1"
          @click.prevent="downloadTerms"
        >
          <span class="font-bold">Download terms and conditions</span>
          <ion-icon name="download-outline"></ion-icon>
        </portal-button>
      </div>
      <div>
        <div class="flex items-center">
          <input
            type="checkbox"
            v-model="formModel.accept_terms"
            class="cursor-pointer mt-05 text-primary-600 checked:bg-green-500 border-2 border-green-800 mr-4"
            style="margin-top: 2px"
            ref="checkbox"
          />
          I accept the above terms and I agree to electronically sign this form.<span class="text-red-600">*</span>
        </div>
        <div class="mt-5">
          <label class="font-bold">Sign to accept proposal<span class="text-red-600 !font-normal">*</span></label>
          <portal-billing-proposal-terms-input
            class="mt-1"
            v-model="formModel.signature"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PortalBillingProposalTermsInput from "./PortalBillingProposalTermsInput.vue"
import PortalButton from "../../../ClientPortal/UI/PortalButtons/PortalButton.vue"
import * as Downloader from "../../../js/helpers/Downloader"
import Proposal from "../../repository/Proposal"
import DateUtils from "../../../js/helpers/DateUtils"

export default {
  name: "PortalBillingProposalTerms",
  components: { PortalButton, PortalBillingProposalTermsInput },
  props: { formModel: { type: Object } },
  emits: ["update-terms-form-model"],
  data() {
    return {
      proposal: window.FinancialCents.proposal,
      uploadedTermsPdf: false,
      termsPdfLoading: true,
    }
  },
  watch: {
    formModel: {
      handler(newValue) {
        this.$emit("update-terms-form-model", newValue)
      },
      deep: true,
    },
  },
  methods: {
    async checkForUploadedTerms() {
      try {
        let { data } = await Proposal.downloadTermsAndConditions(this.proposal)
        this.uploadedTermsPdf = !!data
      } catch (e) {
        console.error(e)
      } finally {
        this.termsPdfLoading = false
      }
    },

    downloadTerms() {
      Downloader.download(route("client-portal.proposals.terms_and_conditions.download", this.proposal))
    },

    formatDate(date) {
      return DateUtils.formatDate(date, "MMM Do, YYYY", false, true)
    },
  },

  async mounted() {
    await this.checkForUploadedTerms()
  },
}
</script>
